(() => {
  const MOVE_THRESHOLD = 12; // これ以上動いたらドラッグ扱い

  function findHrefFromSlide(slide) {
    // data-asf-link があれば最優先
    const d = slide.getAttribute('data-asf-link');
    if (d) return d;

    // asf-slide-link があればそれ
    const a = slide.querySelector('a.asf-slide-link');
    if (a && a.getAttribute('href')) return a.getAttribute('href');

    // それ以外の a があれば保険で拾う
    const any = slide.querySelector('a[href]');
    if (any) return any.getAttribute('href');

    return null;
  }

  function init() {
    const root = document.querySelector('.asf-top-slideshow');
    if (!root) return;

    let down = false;
    let moved = false;
    let sx = 0;
    let sy = 0;

    // ドラッグ判定は「スライド単位」でOK（イベント委譲）
    root.addEventListener(
      'pointerdown',
      (e) => {
        const slide = e.target.closest('.slideshow__slide');
        if (!slide) return;
        down = true;
        moved = false;
        sx = e.clientX;
        sy = e.clientY;
      },
      { passive: true }
    );

    root.addEventListener(
      'pointermove',
      (e) => {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > MOVE_THRESHOLD || Math.abs(e.clientY - sy) > MOVE_THRESHOLD) {
          moved = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'pointerup',
      () => {
        down = false;
      },
      { passive: true }
    );

    // ★ここが肝：captureで先取りし、必ず遷移させる
    root.addEventListener(
      'click',
      (e) => {
        const slide = e.target.closest('.slideshow__slide');
        if (!slide) return;

        // ドラッグ（スワイプ）なら遷移しない
        if (moved) return;

        // ドット/矢印/再生などのUI操作は除外
        if (
          e.target.closest(
            '.slideshow__controls, .slider-buttons, .slider-counter__link, .slideshow__autoplay, .slider-button'
          )
        ) {
          return;
        }

        const href = findHrefFromSlide(slide);
        if (!href) return;

        // スライダー側が preventDefault しても負けないように、こちらで強制
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        window.location.assign(href);
      },
      true // capture
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
